import {
  ApolloClient,
  ApolloLink,
  concat,
  HttpLink,
  InMemoryCache,
} from "@noom/hive-core";
import { appConfig } from "src/config";
import { getAccessToken } from "src/utils/authCookieParser";

function getGraphQLAuthorizationHeader() {
  const token = getAccessToken() ?? appConfig.LOGGED_OUT_BUYFLOW_CLIENT_TOKEN;
  if (token) {
    return `Bearer ${token}`;
  }
  return "";
}

const httpLink = new HttpLink({
  uri: appConfig.GRAPHQL_URL,
});

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      Authorization: getGraphQLAuthorizationHeader(),
    },
  }));

  return forward(operation);
});

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: concat(authMiddleware, httpLink),
});
